import { render, staticRenderFns } from "./GestionPromociones.vue?vue&type=template&id=62a6682f&scoped=true"
import script from "./GestionPromociones.vue?vue&type=script&lang=js"
export * from "./GestionPromociones.vue?vue&type=script&lang=js"
import style1 from "./GestionPromociones.vue?vue&type=style&index=1&id=62a6682f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a6682f",
  null
  
)

export default component.exports